@for (toast of toasts$ | async; track toast; let i = $index) {
  <div @verticalCollapse @triggerChildAnimation>
    <rp-toast [toast]="toast" (closeToast)="close(i)" />
  </div>
}
